export function mouseEventTrigger (element, type) {
  try {
    let click = new MouseEvent(type, {
      'view': window,
      'bubbles': false,
      'cancelable': true
    })

    element.dispatchEvent(click)
  } catch (e) {
    let click = document.createEvent('MouseEvent')
    click.initMouseEvent('click', true, true,
      window, 0, 0, 0, 0, 0,
      false, false, false,
      false, 0, null
    )
    element.dispatchEvent(click)
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/helper/mouseEvents.js